import type { ChartSeries, ChartValueFormat } from '@fruitful/types';
import { LineChart } from 'react-native-gifted-charts';
import type { ColorTokenKey } from 'smoothie';

import {
    CHART_HEIGHT,
    CHART_Y_SECTIONS,
    formatAxisValue,
    getAxisMax,
    getYAxisLabelWidth,
    toChartValue,
    X_AXIS_LABEL_LINES,
} from './chartUtils';

export const LineAreaChart = ({
    series,
    valueFormat,
    chartWidth,
    getColor,
}: {
    series: ChartSeries;
    valueFormat: ChartValueFormat;
    chartWidth: number;
    getColor: (token: ColorTokenKey) => string;
}) => {
    const lineColor = getColor('$fruitfulGreen');
    const fillColor = getColor('$leafLight');
    const data = series.points.map((point) => ({
        value: toChartValue(point.value, valueFormat),
        label: point.label,
    }));
    const maxValue = getAxisMax(
        data.map((point) => point.value),
        CHART_Y_SECTIONS,
    );

    return (
        <LineChart
            data={data}
            color={lineColor}
            thickness={2}
            curved
            areaChart
            startFillColor={fillColor}
            endFillColor={fillColor}
            startOpacity={1}
            endOpacity={0}
            width={chartWidth}
            height={CHART_HEIGHT}
            maxValue={maxValue}
            initialSpacing={16}
            noOfSections={CHART_Y_SECTIONS}
            yAxisThickness={0}
            xAxisThickness={0}
            yAxisLabelWidth={getYAxisLabelWidth(valueFormat)}
            hideRules
            showVerticalLines={false}
            yAxisTextStyle={{ color: getColor('$gray1000'), fontSize: 12 }}
            xAxisLabelTextStyle={{
                color: getColor('$gray1000'),
                fontSize: 12,
                textAlign: 'center',
            }}
            xAxisTextNumberOfLines={X_AXIS_LABEL_LINES}
            formatYLabel={(label) =>
                formatAxisValue(Number(label), valueFormat)
            }
            hideDataPoints
        />
    );
};
